import { render, staticRenderFns } from "./CultureAssetDeliveryInfo.vue?vue&type=template&id=23d29759&scoped=true&"
import script from "./CultureAssetDeliveryInfo.vue?vue&type=script&lang=js&"
export * from "./CultureAssetDeliveryInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d29759",
  null
  
)

export default component.exports